export const foodReservationNotificationTemplate = `<div style="margin: 0; padding-top: 10px; padding-bottom: 10px">
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{customerAmount}} {{customerAmountDescription}}</p>
</div>`
